
const Sonic = () => {
  return (
    <div style={styles.container}>
      <div style={styles.sky}></div>
      <div style={styles.ground}>
        <div style={styles.grassLayer}>
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              style={{
                ...styles.grass,
                left: `${i * 2}%`,
                height: `${Math.random() * 20 + 30}px`,
                animationDelay: `${Math.random() * 2}s`
              }}
            ></div>
          ))}
        </div>
      </div>
      <img
        src="https://media.tenor.com/jD4sqQ5G6hIAAAAj/sonic-running.gif"
        alt="Sonic running"
        style={styles.sonic}
      />
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    background: 'linear-gradient(to bottom, #87CEEB 0%, #98D8E8 50%, #7FBF7F 50%, #6BAF6B 100%)',
  },
  sky: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '50%',
    background: 'linear-gradient(to bottom, #4A90E2 0%, #87CEEB 100%)',
  },
  ground: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '50%',
    background: 'linear-gradient(to bottom, #7FBF7F 0%, #4A7C4A 100%)',
  },
  grassLayer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '60px',
  },
  grass: {
    position: 'absolute',
    bottom: 0,
    width: '3px',
    background: 'linear-gradient(to top, #2E5C2E, #5FAF5F)',
    borderRadius: '2px 2px 0 0',
    animation: 'sway 3s ease-in-out infinite',
  },
  sonic: {
    position: 'absolute',
    bottom: '50px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '150px',
    height: 'auto',
    filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3))',
    animation: 'bounce 0.5s ease-in-out infinite',
  },
};

// Add keyframe animations
const styleSheet = document.styleSheets[0];
const swayKeyframes = `
  @keyframes sway {
    0%, 100% { transform: rotate(0deg); }
    50% { transform: rotate(3deg); }
  }
`;
const bounceKeyframes = `
  @keyframes bounce {
    0%, 100% { transform: translateX(-50%) translateY(0); }
    50% { transform: translateX(-50%) translateY(-10px); }
  }
`;

try {
  styleSheet.insertRule(swayKeyframes, styleSheet.cssRules.length);
  styleSheet.insertRule(bounceKeyframes, styleSheet.cssRules.length);
} catch (e) {
  // Keyframes already exist or other error
}

export default Sonic;